export const formatCurrency = (
  value: number,
  currencyCode: string,
  locale: string = 'en',
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode || 'EUR',
  }).format(value)
}
